import { ViewportType } from '../../../enums';
import { getWSIProjectionPresentation, withWSIProjectionPresentation, } from './wsiProjectionPresentation';
import { getWSIProjectionSnapshot } from './wsiProjectionSnapshot';
import { WSI_PROJECTION_ID, } from './WSIProjectionTypes';
export { getWSIProjectionSnapshot };
export const wsiProjectionAdapter = {
    id: WSI_PROJECTION_ID,
    viewportTypes: [ViewportType.WHOLE_SLIDE_NEXT],
    getSnapshot: (request) => getWSIProjectionSnapshot(request),
    getPresentation: (snapshot, selector) => getWSIProjectionPresentation(snapshot, selector),
    withPresentation: (snapshot, presentation, options) => withWSIProjectionPresentation(snapshot, presentation, options),
};
